import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { of } from 'rxjs';
import { StoreService } from './store.service';

export type LoginType = 'externe' | 'intern';

export interface LoginCredentials {
  type: LoginType;
  email: string;
  password: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  fullAccountState: any;
  currentUser = null;
  constructor(private api: ApiService, private store: StoreService) { }

  me() {
    if (this.currentUser) {
      return of(this.currentUser);
    }
    const seq = this.api.get('/me');
    seq.subscribe((r: any) => {
      this.currentUser = r;
    });
    return seq;
  }
  login(credentials: LoginCredentials) {
    return this.api.post('/login', credentials);
  }

  changePassword(credentials: { login: string; newPassword: string; oldPassword: string }) {
    return this.api.post('/changePassword', credentials);
  }
  register(data) {
    return this.api.post('/inscription', data);
  }

  mofidyPostulant(data) {
    return this.api.post('/modify', data);

  }

  modifyImage(data) {
    return this.api.post('/modifyPhoto', data);
  }

  valider(data) {
    return this.api.post('/forgetPassword', data);
  }
}
